let tmpId = 0;

/**
 * Return a unique number to identify UX elements
 * @returns {number}
 */
export default function uid() {
    return tmpId++;
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/misc/uid.js